import endpoints from "static/endpoints";
import api from "app/lib/api";
import { interpolate } from "utils/string";

export const insuranceList = async () => {
  const response = await api.get(endpoints.insurances.insurances);
  return response.data;
};

export const createInsurance = async (payload) => {
  const response = await api.post(endpoints.insurances.insurances, payload);
  return response;
};

export const updateInsurance = async (id, payload) => {
  const url = interpolate(endpoints.insurances.insurancesById, { id });
  const response = await api.patch(url, payload);
  return response;
};

export const deleteInsurance = async (id) => {
  const url = interpolate(endpoints.insurances.insurancesById, { id });
  const response = await api.delete(url);
  return response;
};
